import React from 'react'
import { loadModule } from '../../../utils/webpack'
import { IMfeComponent, MfeContainer, LazyRemoteComponent, MfeModule, IMfeManifest } from '../types'
import UnavailableMfe from '../components/UnavailableMfe'

const loadMfeComponent = async (name: MfeContainer): Promise<React.FunctionComponent> => {
  try {
    return await loadModule<React.FunctionComponent>(name, MfeModule.MainComponent)
  } catch (err) {
    console.error(`[MFEs] It wasn't possible to load the main component of '${name}'.`, err)
    return UnavailableMfe
  }
}

const getLazyMfeComponent = (name: MfeContainer): LazyRemoteComponent =>
  React.lazy(async () => ({
    default: await loadMfeComponent(name),
  })) as LazyRemoteComponent

export const loadComponents = (manifests: IMfeManifest[]): Array<IMfeComponent> =>
  manifests
    .filter((m) => m.loaded)
    .map(({ name, basePath }) => ({ basePath, component: getLazyMfeComponent(name) }))
